import {useGetTabsList} from "./useGetTabsList";
import {useBreakpoint} from "@brg/ui";
import {LayoutConst} from "../../../core";
import {useGetTabNames} from "./useGetTabNames";
import {NAVBAR_TAB_NAMES} from "./const/navbarTabNames";
import { AppTester } from "supporting";

export const useGetFilteredTabs = (onCloseMenu?: (ev?: any) => void) => {

    const tabsList = useGetTabsList()
    const is992BP = useBreakpoint(LayoutConst.screen.m);
    const isTablet = useBreakpoint(LayoutConst.screen.l);
    const tabNamesList = useGetTabNames();

    return tabNamesList.reduce((acc: any[], tabName: NAVBAR_TAB_NAMES) => {
        // @ts-ignore
        const tab = tabsList[tabName] || null;
        const desktopActive = tab?.desktopOnly && (!isTablet);
        const mobileActive = tab?.mobileOnly && is992BP;
        const anyActive = !tab?.mobileOnly && !tab?.desktopOnly;

        if (tab && (desktopActive || mobileActive || anyActive)) {
            acc.push({
                ...tab,
                action: (ev: any) => {
                    tab.action && tab.action(ev);
                    onCloseMenu && onCloseMenu(ev);
                },
            });
        }
        return acc;
    }, []);
}import {useGetTabsList} from "./useGetTabsList";
import {useBreakpoint} from "@brg/ui";
import {LayoutConst} from "../../../core";
import {useGetTabNames} from "./useGetTabNames";
import {NAVBAR_TAB_NAMES} from "./const/navbarTabNames";
import { AppTester } from "supporting";

export const useGetFilteredTabs = (onCloseMenu?: (ev?: any) => void) => {

    const tabsList = useGetTabsList()
    const is992BP = useBreakpoint(LayoutConst.screen.m);
    const isTablet = useBreakpoint(LayoutConst.screen.l);
    const tabNamesList = useGetTabNames();

    return tabNamesList.reduce((acc: any[], tabName: NAVBAR_TAB_NAMES) => {
        // @ts-ignore
        const tab = tabsList[tabName] || null;
        const desktopActive = tab?.desktopOnly && (!isTablet);
        const mobileActive = tab?.mobileOnly && is992BP;
        const anyActive = !tab?.mobileOnly && !tab?.desktopOnly;

        if (tab && (desktopActive || mobileActive || anyActive)) {
            acc.push({
                ...tab,
                action: (ev: any) => {
                    tab.action && tab.action(ev);
                    onCloseMenu && onCloseMenu(ev);
                },
            });
        }
        return acc;
    }, []);
}